module.exports = __webpack_public_path__ + "static/media/upload-masive.2bcf54cf.svg";